// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"ac77c20d","360":"a3622dda","387":"4da33f8e","641":"2faec204","995":"1b7e4996"}[chunkId] + ".chunk.css";
};